module.exports = __webpack_public_path__ + "static/media/foreground.7626e7ca.svg";